<template>
    <v-layout class="folyamat-sav" column justify-space-between>
        <BnSideBarNavLink
                :ref="item.id"
                :id="item.id"
                :label="item.label"
                v-for="(item, index) in items[$store.getters.currentPage]"
                :onScreenId="currentTopId"
                :index="index"
                :key="index"
        >
        </BnSideBarNavLink>
    </v-layout>
</template>

<script>
import EventBus from '../../modules/EventBus';
import { isPageBottomVisible } from '../../utils/WindowUtils';

export default {
    name: 'BnSideBarNav',
    props: [
        'items',
    ],

    data() {
        return {
            currentTopId: '',
            currentTopsHeight: Infinity,
            lastId: '',
        };
    },

    mounted() {
        const objectKeys = Object.keys(this.items[this.$store.getters.currentPage]);
        const lastIndex = objectKeys.length - 1;
        this.lastId = this.items[this.$store.getters.currentPage][objectKeys[lastIndex]].id;

        EventBus.$on('anchor-entered-screen', ({ id, top }) => {
            if (this.currentTopsHeight > top) {
                this.currentTopId = id;
                if (isPageBottomVisible()) {
                    this.currentTopId = this.lastId;
                }
            }
        });

        EventBus.$on('set-sidebar-link-selected', (id) => {
            this.currentTopId = id;
        });
    },
};
</script>

<style scoped>
    .folyamat-sav{
        position: fixed;
        /*left: 50px;
        top: 100px;*/
    }
</style>
